import React from 'react';
import styled from 'styled-components';
import { Flex } from '@cko/primitives';

import { LoadingItem } from '../LoadingItem';

export const LOADING_NOTIFICATION_ITEM_TEST_ID =
  'notifications-in-navigation-loading-notification-item';

const Wrapper = styled(Flex)`
  flex-direction: column;
  flex-grow: 1;
  justify-content: flex-start;
  margin: var(--layout-spoon) var(--layout-shoebox);
`;

export const LoadingView = () => {
  return (
    <Wrapper>
      <LoadingItem />
      <LoadingItem />
      <LoadingItem />
      <LoadingItem />
    </Wrapper>
  );
};
